import * as React from 'react';
import { Location } from 'types/location.type';

interface LrStreetViewProps {
    location: Partial<Location>;
    height?: string;
    width?: string;
    allowFullScreen?: boolean;
}

const defaultProps = {
    height: '650',
    width: '800',
    allowFullScreen: true,
};

const LrStreetView: React.FunctionComponent<LrStreetViewProps> = (props) => {
    const { location, height, width, allowFullScreen } = { ...props };

    const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

    function formatAddressQuery(locationAddress: Partial<Location>) {
        const { address1, address2, city, state, zip } = locationAddress;
        return `${address1} ${address2}, ${city}, ${state} ${zip}`;
    }

    function googleMapsUrl(l: Partial<Location>) {
        let baseUrl = 'https://www.google.com/maps/embed/v1/';
        // for now we are not doing streetview as simply using lat/lon doesn't produce usable results more than half the time
        // if (l.locationLat && l.locationLon) {
        //     baseUrl += 'streetview';
        // } else {
        baseUrl += 'place';
        // }

        baseUrl += `?key=${GOOGLE_API_KEY}&`;

        // if (l.locationLat && l.locationLon) {
        //     baseUrl += `location=${l.locationLat},${l.locationLon}`;
        // } else {
        if (l.locationplaceId) {
            baseUrl += `q=place_id:${l.locationplaceId}`;
        } else if (l.formattedAddress) {
            baseUrl += `q=${encodeURIComponent(l.formattedAddress)}`;
        } else {
            baseUrl += `q=${encodeURIComponent(formatAddressQuery(location))}`;
        }
        baseUrl += '&maptype=satellite';
        // }
        return baseUrl;
    }

    return (
        <>
            <iframe
                width={width}
                height={height}
                frameBorder="0"
                title="location street view"
                src={googleMapsUrl(location)}
                allowFullScreen={allowFullScreen}
            />
        </>
    );
};

LrStreetView.defaultProps = defaultProps;
export default LrStreetView;
